import { default as grid } from "./grid";
import GridItem from "./gridItem";

export type { GridProps } from "./grid";
export type { GridItemProps } from "./gridItem";

const Grid = Object.assign(grid, {
  Item: GridItem,
});

export default Grid;
